/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Butter Bar Reducer
 */

import { filterActions } from '@zumper/redux-ignore'

import { ADD_BUTTER_BAR, REMOVE_BUTTER_BAR } from '../actions/constants'

const defaultButterBarState = {
  stack: [],
}

const whitelist = [ADD_BUTTER_BAR, REMOVE_BUTTER_BAR]

const butterBarReducer = function butterBar(state = defaultButterBarState, action) {
  switch (action.type) {
    case ADD_BUTTER_BAR:
      if (action.butterBar && action.butterBar.persistent) {
        return {
          ...state,
          stack: [action.butterBar, ...state.stack],
        }
      } else {
        if (state.stack && state.stack.length) {
          // Make sure another butter with the same message doesn't exist.
          // We do not need to show the butter with the same message twice.
          // Instead, we just remove the old one and add a new one.
          const filteredStack = state.stack.filter((butterBarRef) => {
            if (butterBarRef && butterBarRef.message === action.butterBar.message) {
              butterBarRef.removeHandler && clearTimeout(butterBarRef.removeHandler)
              return undefined
            }
            return true
          })

          // new butter bar, concat it
          if (filteredStack && filteredStack.length) {
            return {
              ...state,
              stack: [...filteredStack, action.butterBar],
            }
          }
          // adding same butter, don't do anything
          return state
        }

        return {
          ...state,
          stack: [action.butterBar],
        }
      }
    case REMOVE_BUTTER_BAR:
      return {
        ...state,
        stack: state.stack.filter((butterBarRef) => {
          return action.butterBarId !== butterBarRef.bbId
        }),
      }
    default:
      return state
  }
}

export default filterActions(butterBarReducer, whitelist)
